const ProgressBar = ({ progress }) => {
  return (
    <div className="flex items-center space-x-3">
      <div className="w-full h-1 overflow-hidden bg-gray-200 rounded-full">
        <div style={{ width: `${progress}%` }} className="h-full bg-tertiary" />
      </div>
      <div className="text-xs font-secondary">{progress}%</div>
    </div>
  );
};

ProgressBar.SIZE = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
};

export default ProgressBar;
